export const TERMS_AND_CONDITIONS_URL =
  "https://files.alpaca.markets/disclosures/library/ACATS+Promotions+Terms+%26+Conditions.pdf";
